import React, { FC, PropsWithChildren } from 'react';

import DeepLinkWizard from '../../common/DeepLinkWizard';
import SignInWithLinkContent from './SignInWithLinkContent';

const SignInWithLink: FC<PropsWithChildren> = ({ children }) => (
  <DeepLinkWizard>
    <SignInWithLinkContent>{children}</SignInWithLinkContent>
  </DeepLinkWizard>
);

export default SignInWithLink;
